// import { createRouter, createWebHashHistory } from "vue-router";
import { createRouter, createWebHistory } from "vue-router";
import { scrollToTop } from "@/js/modal.js";
import useSearch from "@/stores/search";
import { validateLoginToken } from "@/utils/auth";
const routes = [
  {
    path: "/",
    redirect: "/index",
    children: [
      {
        path: "/index",
        name: "首页",
        // component: () => import("@/views/AppMain.vue"),
        component: () => import("@/views/home"),
      },
      {
        path: "/courseList",
        name: "课程列表",
        component: () => import("@/views/CourseList"),
      },
      {
        path: "/searchList",
        name: "检索列表",
        component: () => import("@/views/searchList"),
      },
      {
        path: "/partner",
        name: "合作商",
        component: () => import("@/views/partner"),
      },
      {
        path: "/courseDetails",
        name: "课程详情",
        component: () => import("@/views/CourseList/CourseDetails"),
      },
      {
        path: "/courseVideo",
        name: "课程视频",
        meta: { title: "课程视频" },
        component: () => import("@/views/CourseList/CourseDetails/CourseVideo"),
      },
      {
        path: "/CourseOnlyVideo",
        name: "课程分享视频",
        meta: { title: "课程分享视频" },
        component: () => import("@/views/CourseList/CourseDetails/CourseOnlyVideo"),
      },
      {
        path: "/individualCenter",
        name: "个人中心",
        component: () => import("@/views/IndividualCenter"),
      },
      {
        path:'/login',
        name: '登录',
        component: () => import("@/views/loginRouter"),
      },
      {
        //匹配未定义路由 然后重定向至首页
        path: "/:pathMath(.*)",
        redirect: "/",
      },
    ],
  },
];
const router = createRouter({
  // history: createWebHashHistory(),
  history: createWebHistory(),
  routes,
});
router.beforeEach(async (to, from, next) => {
  document.title = to.name;
  if (window.location.protocol === 'http:' && process.env.NODE_ENV === 'production') {
    // window.location.href = window.location.href.replace('http:', 'https:');
  }
  await validateLoginToken();
  next();
});
router.afterEach((to, from) => {
  const searchStore = useSearch();
  if (to.path != "/searchList") {
    searchStore.keyWord = "";
    // console.log("置空",searchStore.keyWord);
  }
  scrollToTop();
});
export default router;
